import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  loadingTitle: {
    defaultValue: 'Analisando os principais nichos agora',
    key: 'PendingNiche-loadingTitle',
  },

  loadingText: {
    defaultValue: 'Em breve você terá acesso aos assuntos que mais mobilizaram engajamento nos últimos 12 meses.',
    key: 'PendingNiche-loadingText',
  },
  loadingTextSevenDays: {
    defaultValue: 'Em breve você terá acesso aos assuntos que mais mobilizaram engajamento nos últimos 7 dias.',
    key: 'PendingNiche-loadingTextSevenDays',
  },
})
